function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import { Constants } from '../utils/constants';
import { urlPush, routes, urlReplace } from '@shared/routerHistory';
import { InboundMessagesHandler } from '../partnersProtocol/inboundMessagesHandler';
import { OutboundMessagesHandler } from '../partnersProtocol/outboundMessagesHandler';
const PARTNERS_IFRAME_ID = 'partnersIframe';
const IFRAME_DEFAULT_HEIGHT = '1000px';
export class PartnersHost extends SpzaComponent {
    componentWillUnmount() {
        if (!this.props.serverRendering) {
            this.inboundMessagesHandler.stopHandleInboundMessages();
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
    }
    componentDidMount() {
        if (!this.props.serverRendering) {
            this.inboundMessagesHandler.startHandleInboundMessages();
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
            this.setState({
                src: this.props.partnersFixedSourceUrl
            });
        }
    }
    componentDidUpdate() {
        const { user } = this.props;
        const { requestedLoginWhileLoading } = this.state;
        if (!this.props.serverRendering) {
            this.updateIframeData();
        }
        // Check if a login request was made while loading and launch the login dialog if necessary
        if (requestedLoginWhileLoading && !user.loading) {
            this.onLoginRequest(true);
        }
    }
    getCountry() {
        if (this.props.user.signedIn && this.props.billingCountryCode) {
            return this.props.billingCountryCode;
        }
        return null;
    }
    getEmail() {
        if (this.props.user.email) {
            return this.props.user.email;
        }
        if (this.props.user.profile && this.props.user.profile.email) {
            return this.props.user.profile.email;
        }
        return null;
    }
    getPhone() {
        if (this.props.user.phone) {
            return this.props.user.phone;
        }
        if (this.props.user.profile && this.props.user.profile.phone) {
            return this.props.user.profile.phone;
        }
        return null;
    }
    getCompany() {
        if (this.props.user.company) {
            return this.props.user.company;
        }
        if (this.props.user.profile && this.props.user.profile.company) {
            return this.props.user.profile.company;
        }
        return null;
    }
    getTitle() {
        if (this.props.user.title) {
            return this.props.user.title;
        }
        if (this.props.user.profile && this.props.user.profile.title) {
            return this.props.user.profile.title;
        }
        return null;
    }
    renderImpl() {
        return /*#__PURE__*/ _jsx("div", {
            // eslint-disable-next-line react/forbid-dom-props
            id: "maincontent",
            children: /*#__PURE__*/ _jsx("iframe", {
                title: this.context.loc('Appsource_Header_Partners', 'Partners'),
                className: "partners-host-client-render-box",
                allow: "geolocation",
                ref: this.frameRef,
                // eslint-disable-next-line react/forbid-dom-props
                id: PARTNERS_IFRAME_ID,
                width: "100%",
                height: this.state.iFrameHeight,
                src: this.state.src
            })
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "inboundMessagesHandler", void 0), _define_property(this, "outboundMessagesHandler", void 0), _define_property(this, "frameRef", void 0), _define_property(this, "onLoginRequest", (bypassLoadingCheck = false)=>{
            const { user } = this.props;
            const { requestedLoginWhileLoading } = this.state;
            if (!bypassLoadingCheck && user.loading) {
                // If the user login state hasn't been fully loaded yet,
                // Register the login request to be made when done
                this.setState({
                    requestedLoginWhileLoading: true
                });
            } else {
                if (!user || !user.signedIn) {
                    this.context.ctaCallback({
                        entity: this.props,
                        entityType: Constants.EntityType.Partner,
                        ctaType: Constants.CTAType.Partner,
                        actionModifier: Constants.Telemetry.ActionModifier.PartnerCTAButton
                    });
                }
                if (requestedLoginWhileLoading) {
                    this.setState({
                        requestedLoginWhileLoading: false
                    });
                }
            }
        }), _define_property(this, "onPartnersViewReady", ()=>{
            this.updateIframeData();
            this.handleResize();
        }), _define_property(this, "onChangeUrlGalleryRequest", (filter, contact, replaceUrl)=>{
            const filterParams = {
                filter,
                contact
            };
            const url = this.context.buildHref(routes.marketplacePartners, null, filterParams);
            this.changeUrl(url, replaceUrl);
        }), _define_property(this, "changeUrl", (url, replace)=>{
            if (replace) {
                urlReplace(url);
            } else {
                urlPush(url, true);
            }
        }), _define_property(this, "onStoreFilterLocationRequest", (filterLocation)=>{
            if (this.props.storeFilterLocation) {
                this.props.storeFilterLocation(filterLocation);
            }
        }), _define_property(this, "onStoreContactDetailsRequest", (contactDetails)=>{
            if (this.props.storeContactDetails) {
                this.props.storeContactDetails(contactDetails);
            }
        }), _define_property(this, "onChangeUrlDetailsRequest", (partnerId, tab, contact, replaceUrl)=>{
            if (!partnerId) {
                return;
            }
            const routeParams = {
                entityId: partnerId,
                tabId: tab
            };
            const url = contact ? this.context.buildHref(routes.marketplacePartnerDetailContact, routeParams, null) : this.context.buildHref(routes.marketplacePartnerDetail, routeParams, null);
            this.changeUrl(url, replaceUrl);
        }), _define_property(this, "onContentHeightChanged", (height)=>{
            this.setState({
                iFrameHeight: height
            });
        }), _define_property(this, "updateIframeData", ()=>{
            const context = {
                user: {
                    firstName: this.props.user.firstName,
                    lastName: this.props.user.lastName,
                    signedIn: this.props.user.signedIn,
                    accessToken: this.props.user.accessToken ? this.props.user.accessToken.spza : null,
                    country: this.getCountry(),
                    email: this.getEmail(),
                    phone: this.getPhone(),
                    company: this.getCompany(),
                    title: this.getTitle()
                },
                hostUrl: this.props.hostUrl,
                partnersUrl: this.props.partnersUrl,
                filterLocation: this.props.filterLocation,
                contactDetails: this.props.contactDetails
            };
            this.outboundMessagesHandler.postSetDataMessage(context);
        }), _define_property(this, "handleScroll", ()=>{
            if (!this.props.serverRendering) {
                this.outboundMessagesHandler.postScrollChangeMessage(window.pageXOffset, window.pageYOffset);
            }
        }), _define_property(this, "handleResize", ()=>{
            if (!this.props.serverRendering) {
                const iframeElement = this.frameRef.current;
                const { innerWidth, innerHeight } = window;
                const { left, top } = iframeElement && iframeElement.getBoundingClientRect() || {
                    left: 0,
                    top: 0
                };
                this.outboundMessagesHandler.postSizeChangeMessage({
                    width: innerWidth,
                    height: innerHeight,
                    frameLeft: left,
                    frameTop: top
                });
            }
        });
        this.frameRef = /*#__PURE__*/ React.createRef();
        this.state = {
            iFrameHeight: IFRAME_DEFAULT_HEIGHT,
            requestedLoginWhileLoading: false,
            src: null
        };
        const partnerInboundCallbacks = {
            onPartnersViewReady: this.onPartnersViewReady,
            onLoginRequest: this.onLoginRequest,
            onChangeUrlGalleryRequest: this.onChangeUrlGalleryRequest,
            onStoreFilterLocationRequest: this.onStoreFilterLocationRequest,
            onStoreContactDetailsRequest: this.onStoreContactDetailsRequest,
            onChangeUrlDetailsRequest: this.onChangeUrlDetailsRequest,
            onContentHeightChanged: this.onContentHeightChanged
        };
        this.inboundMessagesHandler = new InboundMessagesHandler(props.iframeBaseAddress, partnerInboundCallbacks);
        this.outboundMessagesHandler = new OutboundMessagesHandler(PARTNERS_IFRAME_ID, this.props.partnersFixedSourceUrl);
    }
}
PartnersHost.contextTypes = {
    ctaCallback: PropTypes.func,
    buildHref: PropTypes.func,
    loc: PropTypes.func
};
